import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface DesignNibPlusIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const DesignNibPlusIcon = ({ className, ...props }: DesignNibPlusIconProps) => (
  <svg
    className={cn("text-light-400", className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_580_31062)">
      <mask
        fill="currentColor"
        height="22"
        id="path-1-outside-1_580_31062"
        maskUnits="userSpaceOnUse"
        width="22"
        x="1.16968"
        y="0.94162"
      >
        <rect
          fill="white"
          height="22"
          width="22"
          x="1.16968"
          y="0.94162"
        />
        <path d="M15.1404 2.74728C16.2143 1.67351 17.9552 1.6734 19.0291 2.74728L21.1501 4.86838C22.2241 5.94232 22.2241 7.68408 21.1501 8.75803L18.4285 11.4787C18.4175 11.5344 18.4047 11.5901 18.3865 11.6447L16.4812 17.3606C16.3419 17.7784 16.0069 18.1022 15.5847 18.2278L3.90698 21.6985L3.71265 21.7434C2.80973 21.8772 2.02869 21.0692 2.19214 20.1711L2.24194 19.9778L6.03296 8.60471C6.15702 8.23254 6.43683 7.93184 6.79956 7.78244L12.1863 5.56564C12.2513 5.53887 12.3176 5.51733 12.3845 5.50119L15.1404 2.74728Z" />
      </mask>
      <path
        d="M15.1404 2.74728C16.2143 1.67351 17.9552 1.6734 19.0291 2.74728L21.1501 4.86838C22.2241 5.94232 22.2241 7.68408 21.1501 8.75803L18.4285 11.4787C18.4175 11.5344 18.4047 11.5901 18.3865 11.6447L16.4812 17.3606C16.3419 17.7784 16.0069 18.1022 15.5847 18.2278L3.90698 21.6985L3.71265 21.7434C2.80973 21.8772 2.02869 21.0692 2.19214 20.1711L2.24194 19.9778L6.03296 8.60471C6.15702 8.23254 6.43683 7.93184 6.79956 7.78244L12.1863 5.56564C12.2513 5.53887 12.3176 5.51733 12.3845 5.50119L15.1404 2.74728Z"
        fill="white"
      />
      <path
        d="M15.1404 2.74728L15.4938 3.10096L15.4939 3.10087L15.1404 2.74728ZM21.1501 4.86838L21.5037 4.51482L21.1501 4.86838ZM21.1501 8.75803L21.5036 9.11164L21.5037 9.11158L21.1501 8.75803ZM18.4285 11.4787L18.075 11.1251C18.0048 11.1953 17.9571 11.2847 17.9379 11.3821L18.4285 11.4787ZM18.3865 11.6447L18.8608 11.8029L18.8608 11.8028L18.3865 11.6447ZM16.4812 17.3606L16.9555 17.5188L16.9555 17.5187L16.4812 17.3606ZM15.5847 18.2278L15.7272 18.707L15.7272 18.707L15.5847 18.2278ZM3.90698 21.6985L4.01959 22.1856C4.02962 22.1833 4.03957 22.1807 4.04943 22.1777L3.90698 21.6985ZM3.71265 21.7434L3.78593 22.238C3.79913 22.236 3.81225 22.2335 3.82526 22.2305L3.71265 21.7434ZM2.19214 20.1711L1.70794 20.0464C1.70495 20.058 1.70237 20.0698 1.70022 20.0816L2.19214 20.1711ZM2.24194 19.9778L1.7676 19.8196C1.76393 19.8307 1.76064 19.8418 1.75775 19.853L2.24194 19.9778ZM6.03296 8.60471L5.55862 8.44659L5.55862 8.44659L6.03296 8.60471ZM6.79956 7.78244L6.60928 7.32006L6.60914 7.32012L6.79956 7.78244ZM12.1863 5.56564L12.3766 6.02802L12.3767 6.02798L12.1863 5.56564ZM12.3845 5.50119L12.5017 5.98727C12.5911 5.96572 12.6729 5.9199 12.7379 5.85487L12.3845 5.50119ZM15.1404 2.74728L15.4939 3.10087C16.3726 2.22229 17.7969 2.22224 18.6755 3.10084L19.0291 2.74728L19.3826 2.39373C18.1134 1.12455 16.056 1.12474 14.7869 2.3937L15.1404 2.74728ZM19.0291 2.74728L18.6755 3.10084L20.7966 5.22193L21.1501 4.86838L21.5037 4.51482L19.3826 2.39373L19.0291 2.74728ZM21.1501 4.86838L20.7966 5.22193C21.6753 6.10061 21.6753 7.52579 20.7966 8.40447L21.1501 8.75803L21.5037 9.11158C22.7729 7.84238 22.7729 5.78403 21.5037 4.51482L21.1501 4.86838ZM21.1501 8.75803L20.7967 8.40441L18.075 11.1251L18.4285 11.4787L18.782 11.8323L21.5036 9.11164L21.1501 8.75803ZM18.4285 11.4787L17.9379 11.3821C17.9287 11.4285 17.9207 11.4608 17.9121 11.4867L18.3865 11.6447L18.8608 11.8028C18.8887 11.7193 18.9063 11.6402 18.919 11.5753L18.4285 11.4787ZM18.3865 11.6447L17.9121 11.4866L16.0069 17.2025L16.4812 17.3606L16.9555 17.5187L18.8608 11.8029L18.3865 11.6447ZM16.4812 17.3606L16.0069 17.2024C15.9192 17.4652 15.7082 17.6694 15.4422 17.7485L15.5847 18.2278L15.7272 18.707C16.3056 18.535 16.7645 18.0915 16.9555 17.5188L16.4812 17.3606ZM15.5847 18.2278L15.4423 17.7485L3.76454 21.2192L3.90698 21.6985L4.04943 22.1777L15.7272 18.707L15.5847 18.2278ZM3.90698 21.6985L3.79437 21.2113L3.60004 21.2562L3.71265 21.7434L3.82526 22.2305L4.01959 22.1856L3.90698 21.6985ZM3.71265 21.7434L3.63937 21.2488C3.07554 21.3323 2.58185 20.8222 2.68406 20.2606L2.19214 20.1711L1.70022 20.0816C1.47553 21.3161 2.54391 22.422 3.78593 22.238L3.71265 21.7434ZM2.19214 20.1711L2.67633 20.2958L2.72614 20.1025L2.24194 19.9778L1.75775 19.853L1.70794 20.0464L2.19214 20.1711ZM2.24194 19.9778L2.71628 20.1359L6.5073 8.76282L6.03296 8.60471L5.55862 8.44659L1.7676 19.8196L2.24194 19.9778ZM6.03296 8.60471L6.5073 8.76282C6.5856 8.52793 6.76213 8.3386 6.98998 8.24476L6.79956 7.78244L6.60914 7.32012C6.11152 7.52507 5.72844 7.93714 5.55862 8.44659L6.03296 8.60471ZM6.79956 7.78244L6.98984 8.24482L12.3766 6.02802L12.1863 5.56564L11.996 5.10327L6.60928 7.32006L6.79956 7.78244ZM12.1863 5.56564L12.3767 6.02798C12.4184 6.01079 12.4602 5.99727 12.5017 5.98727L12.3845 5.50119L12.2674 5.01511C12.1749 5.03739 12.0842 5.06695 11.9959 5.1033L12.1863 5.56564ZM12.3845 5.50119L12.7379 5.85487L15.4938 3.10096L15.1404 2.74728L14.787 2.39361L12.0311 5.14751L12.3845 5.50119Z"
        fill="white"
        mask="url(#path-1-outside-1_580_31062)"
      />
      <path
        d="M17.6744 11.4075L15.7691 17.1233C15.7072 17.309 15.5586 17.4529 15.3709 17.5087L3.69348 20.9803C3.22819 21.1186 2.79978 20.676 2.95328 20.2155L6.74467 8.84131C6.79981 8.67588 6.92419 8.54263 7.08543 8.47624L12.472 6.25822C12.696 6.166 12.9535 6.21749 13.1248 6.38876L17.5294 10.7935C17.6901 10.9542 17.7463 11.1919 17.6744 11.4075Z"
        fill="white"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M3.29602 20.6016L9.65998 14.2377"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M20.6201 8.22724L17.7916 11.0557L12.8419 6.10592L15.6703 3.27749C16.4514 2.49644 17.7177 2.49644 18.4987 3.27749L20.6201 5.39881C21.4011 6.17986 21.4011 7.44619 20.6201 8.22724Z"
        fill="white"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M11.7812 12.1163C11.1955 11.5305 10.2457 11.5305 9.65992 12.1163C9.07413 12.7021 9.07413 13.6519 9.65992 14.2376C10.2457 14.8234 11.1955 14.8234 11.7812 14.2376C12.367 13.6519 12.367 12.7021 11.7812 12.1163Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M19.8867 15.8868C20.439 15.8868 20.8867 16.3345 20.8867 16.8868V18.8868H22.8867C23.439 18.8868 23.8867 19.3345 23.8867 19.8868C23.8867 20.4391 23.439 20.8868 22.8867 20.8868H20.8867V22.8868C20.8867 23.4391 20.439 23.8868 19.8867 23.8868C19.3344 23.8868 18.8867 23.4391 18.8867 22.8868V20.8868H16.8867C16.3344 20.8868 15.8867 20.4391 15.8867 19.8868C15.8867 19.3345 16.3344 18.8868 16.8867 18.8868H18.8867V16.8868C18.8867 16.3345 19.3344 15.8868 19.8867 15.8868Z"
        fill="currentColor"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.5"
      />
    </g>
    <defs>
      <clipPath id="clip0_580_31062">
        <rect
          fill="white"
          height="24"
          width="24"
        />
      </clipPath>
    </defs>
  </svg>
);

export default DesignNibPlusIcon;
